import React from "react";
import Modal from "../../../../_components/Modal";
import Button from "../../../../_components/Button";
// import { Form } from "../../../../_components/Form";
import Text from "../../../../_components/Text";
import { FormControl } from "react-bootstrap";
// import { formFields, formOptions } from "./data";
import AutoComplete from "../../Financial/AutoComplete";
import { filterSales } from "../../../../api/sales";
import LoadingInput from "../../../../_components/LoadingInput";
import { getClients } from "../../../../api/clients";
import { toast } from "react-toastify"

export default (props) => {
  const [show, setShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [filterData, setFilterData] = React.useState({});

  const modelChoices = {

    1: "Todas",
    2: "Gerencial",
    3: "NF-e",
    4: "NFC-e",
  }

  const statusChoices = {

    1: "Todas",
    2: "Autorizadas",
    3: "Canceladas",
  }

  const endCountChoices = {

    1: 10,
    2: 20,
    3: 50,
    4: 100,
    5: 200,
    6: 500,
  }

  function onChange(e) {

    let { name, value } = e.target
    let tempData = { ...filterData }
    tempData[name] = value

    if (name === 'end_created_date') {
      let date = new Date(value)
      date.setDate(date.getDate() + 1)
      let newDate = date.toISOString().split('T')[0]
      tempData[name] = newDate
    }

    setFilterData(tempData)
  }


  function onFilter(data) {
    setLoading(true);
    setTimeout(() => {

      if (props.bindData) {
        props.bindData({
          end_count: 10,
          ...filterData,
        });
      }

      filterSales(filterData)
        .then((resp) => {
          if (props.setResult) {
            props.setResult(resp);
          }
        })
        .finally(() => {
          setLoading(false);
          closeModal();
        });
    }, 200);
  }
  function showModal() {
    setShow(true);
  }
  function closeModal() {
    setShow(false);
  }

  return (
    <React.Fragment>
      <Button onClick={showModal}>
        Filtrar Vendas <i className="fas fa-filter pl-3" />
      </Button>
      <Modal size="xl" title="Pesquisar vendas" show={show} onHide={closeModal}>


        <div className="container row" id="modal-create">
          <div className="col-12">
            <div className="text-center m-0 py-2">
              <span className=""></span>
            </div>
          </div>

          <div className='col-lg-6 col-sm-12'>
            <div className='form-group'>
              <div>
                <div>
                  <Text color='primary'>
                    Código da venda:
                  </Text>
                </div>
                <div>
                  <FormControl
                    required
                    type="number"
                    name='code'
                    placeholder='Insira um código'
                    disabled={loading}
                    onChange={onChange}
                    value={filterData.code}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12">
            <div className="form-group">

              <div>
                <div>
                  <Text color='primary'>
                    Modelo:
                  </Text>
                </div>
                <FormControl
                  loading={loading}
                  name="invoice_type"
                  onChange={onChange}
                  as="select" >
                  <option selected={modelChoices == 1} value=''>Todas</option>
                  <option selected={modelChoices == 2} value='-1'>Gerencial</option>
                  <option selected={modelChoices == 3} value='1'>NF-e</option>
                  <option selected={modelChoices == 4} value='2'>NFC-e</option>
                </FormControl>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-sm-12'>
            <div className='form-group'>
              <div>
                <div>
                  <Text color='primary'>
                    Data Inicial:
                  </Text>
                </div>
                <div>
                  <LoadingInput name="start_created_date" onChange={onChange} type="date" />
                </div>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-sm-12'>
            <div className='form-group'>
              <div>
                <div>
                  <Text color='primary'>
                    Data Final:
                  </Text>
                </div>
                <div>
                  <LoadingInput name="end_created_date" onChange={onChange} type="date" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12">
            <div className="form-group">

              <div>
                <div>
                  <Text color='primary'>
                    Status:
                  </Text>
                </div>
                <FormControl
                  loading={loading}
                  name="status"
                  onChange={onChange}
                  as="select" >
                  <option selected={statusChoices == 1} value=''>Todas</option>
                  <option selected={statusChoices == 2} value='2'>Autorizadas</option>
                  <option selected={statusChoices == 3} value='3'>Canceladas</option>
                </FormControl>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12">
            <div className="form-group">

              <div>
                <div>
                  <Text color='primary'>
                    Exibir Até:
                  </Text>
                </div>
                <FormControl
                  loading={loading}
                  name="end_count"
                  onChange={onChange}
                  as="select" >
                  <option selected={endCountChoices == 1} value={10}>10 Resultados</option>
                  <option selected={endCountChoices == 2} value={20}>20 Resultados</option>
                  <option selected={endCountChoices == 3} value={50}>50 Resultados</option>
                  <option selected={endCountChoices == 4} value={100}>100 Resultados</option>
                  <option selected={endCountChoices == 5} value={200}>200 Resultados</option>
                  <option selected={endCountChoices == 6} value={500}>500 Resultados</option>
                </FormControl>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12">
            <div className="form-group">
              <div>
                <div>
                  <Text color='primary'>
                    Cliente:
                  </Text>
                </div>
                <AutoComplete

                  request={getClients}
                  searchField='name'
                  labelField='name'
                  valueField='id'
                  onChange={e => {
                    onChange({ target: { name: 'client', value: e.value } })
                  }}
                  onSelect={e => {
                    onChange({ target: { name: 'client', value: e.value } })
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="d-flex justify-content-center">
              <Button disabled={loading} onClick={onFilter}>
                Pesquisar
              </Button>
            </div>
          </div>
        </div>

      </Modal>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Sales/Filter/index.jsx